export const aboutGameTextContent = {
  headingText: "About Game",
};
